import { renderValueSafeInline } from  "./valueFormat"

// Hjelper: avgjør om et verdi-objekt indikerer "lampen svarer ikke"
const lampStatusIsNotResponding = (obj) => {
  if (!obj || typeof obj !== "object") return false;
  // sjekk vanlige status-feltnavn
  const statusKeys = ["status", "s", "stat", "state"];
  for (const k of statusKeys) {
    const v = obj[k];
    if (
      typeof v === "string" &&
      v.length > 0 &&
      v.charAt(0).toLowerCase() === "r"
    )
      return true;
  }
  return false;
};

// Hjelper: finn numerisk prosentverdi i et objekt/primitive
const extractLampPercent = (el) => {
  if (el === null || el === undefined) return null;

  // primitive number => prosent
  if (typeof el === "number") return el;

  // primitive string that contains digits (e.g. "45", "45.0", "45%")
  if (typeof el === "string") {
    const num = parseFloat(el.replace("%", "").trim());
    return isNaN(num) ? null : num;
  }

  // object: look for common keys
  if (typeof el === "object") {
    const keysToCheck = [
      "percent",
      "pct",
      "value",
      "val",
      "V",
      "v",
      "level",
      "levelPct",
      "percentaje",
      "p",
    ];
    for (const k of keysToCheck) {
      if (Object.prototype.hasOwnProperty.call(el, k)) {
        const v = el[k];
        if (typeof v === "number") return v;
        if (typeof v === "string") {
          const num = parseFloat(String(v).replace("%", "").trim());
          if (!isNaN(num)) return num;
        }
      }
    }

    // fallback: try some known nested spots (e.g. { D1: { value: 12 } })
    const entries = Object.entries(el);
    for (const [, v] of entries) {
      if (v != null && (typeof v === "number" || typeof v === "string")) {
        const num =
          typeof v === "number"
            ? v
            : parseFloat(String(v).replace("%", "").trim());
        if (!isNaN(num)) return num;
      }
    }
  }

  return null;
};

// Lamper 1..6 — bruker over hjelpere
export const renderLamperSixLines = (lamper) => {
  const lines = [];
  for (let i = 0; i < 6; i++) {
    const el = Array.isArray(lamper)
      ? lamper[i]
      : typeof lamper === "object" && lamper !== null
      ? Object.values(lamper)[i]
      : i === 0
      ? lamper
      : null;

    // Sjekk "lampe svarer ikke" først (objekt med status 'r')
    if (lampStatusIsNotResponding(el)) {
      lines.push(
        <div key={i} style={{ marginBottom: 2 }}>
          <strong>{i + 1}:</strong> <em>Lampe svarer ikke</em>
        </div>
      );
      continue;
    }

    // Sjekk om vi kan hente en prosentverdi
    const pct = extractLampPercent(el);
    if (pct !== null) {
      // Vis heltall hvis mulig, ellers én desimal
      const formatted = Number.isInteger(pct)
        ? `${pct}%`
        : `${pct.toFixed(1)}%`;
      lines.push(
        <div key={i} style={{ marginBottom: 2 }}>
          <strong>{i + 1}:</strong> {formatted}
        </div>
      );
      continue;
    }

    // Hvis el er truthy primitive/string uten prosent, vis det med default formattering
    if (el === null || el === undefined) {
      lines.push(
        <div key={i} style={{ marginBottom: 2 }}>
          <strong>{i + 1}:</strong> <span className="hyphen">-</span>
        </div>
      );
      continue;
    }

    // Ellers fallback: trygg inline rendering (kort)
    lines.push(
      <div key={i} style={{ marginBottom: 2 }}>
        <strong>{i + 1}:</strong> {renderValueSafeInline(el)}
      </div>
    );
  }

  return <div style={{ lineHeight: "1.25" }}>{lines}</div>;
};
